import { MediaConfig } from 'features/CaseStudy/types';
import { useOnInView } from 'react-intersection-observer';

type MediaProps = {
  mediaConfig: MediaConfig;
  className?: string;
};

export const Media = ({ mediaConfig, className }: MediaProps) => {
  const inViewRef = useOnInView<HTMLVideoElement>(
    (inView, entry) => {
      if (inView) {
        entry.target.play();
      }
    },
    { triggerOnce: true }, // Optional IntersectionObserver options
  );

  if (mediaConfig.type === 'image') {
    return <img src={mediaConfig.src} alt={mediaConfig.alt ?? ''} className={className} />;
  } else {
    return <video ref={inViewRef} src={mediaConfig.src} loop={mediaConfig.loop} muted className={className} />;
  }
};
